    <div class="low-navbar-account" >
        <ul>
            @for(item of navItems; track item.item){
                <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
                    <a (click)="triggerAction(item.item)">{{ item.name }}</a>
                </li>
            }
        </ul>
        <hr >
    </div>
    <app-recursos-budget *ngIf="navItems[0].active" [presupuesto_id]="presupuesto_id"></app-recursos-budget>
    <app-activities *ngIf="navItems[1].active"></app-activities>
    <app-version-budget *ngIf="navItems[2].active" [presupuesto_id]="presupuesto_id"></app-version-budget>